import axios from 'axios';

const lookupApi = axios.create({
    baseURL: process.env.REACT_APP_LOOKUP_API_URL
});

export default lookupApi;